import type { UUID } from "../types/primitives";

export const generateUuid = (): UUID => {
  if (typeof globalThis !== "undefined") {
    const cryptoRef = (globalThis as unknown as { crypto?: Crypto }).crypto;
    if (cryptoRef && typeof cryptoRef.randomUUID === "function") {
      try {
        return cryptoRef.randomUUID() as UUID;
      } catch {
        // fall back below
      }
    }
  }

  const time = Date.now().toString(36);
  const random = Math.random().toString(36).slice(2);
  return `uuid_${time}_${random}` as UUID;
};
